module.exports = __webpack_public_path__ + "static/media/mistletoe.2b763f16.svg";